import React from "react";
import { Link } from "react-router-dom";

const NOTES = [
  {
    to: "/enterprise-2/research",
    tone: "forest",
    tag: "Benchmark",
    date: "Jul 2025",
    read: "4 min read",
    cover: "DeepResearch Bench",
    title: "An agent built on Atom placed second overall at 53.70, and first on insight at 57.2, ahead of Gemini 2.5 Pro.",
    testid: "e2-thinking-1",
  },
  {
    to: "/enterprise-2/blog",
    tone: "navy",
    tag: "Perspective",
    date: "Coming soon",
    read: "6 min read",
    cover: "Entity resolution as the moat that lasts.",
    title: "Why the durable value of a deployment lives in the resolved entities behind the documents, not the documents themselves.",
    testid: "e2-thinking-2",
  },
  {
    to: "/enterprise-2/blog",
    tone: "teal",
    tag: "Perspective",
    date: "Coming soon",
    read: "5 min read",
    cover: "Sovereign clouds and the 155-country line.",
    title: "The data-residency map is redrawing itself. What it changes for the institutions that must operate inside it.",
    testid: "e2-thinking-3",
  },
];

const Arrow = () => (
  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden>
    <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export function LatestThinking() {
  return (
    <div className="e2-thinking" data-testid="e2-thinking">
      <div className="e2-thinking-head">
        <div>
          <div className="e2-eyebrow">Latest thinking</div>
          <p className="e2-h-l" style={{ maxWidth: "20ch", marginTop: 14 }}>
            Ideas we have tested, and are happy to stand behind.
          </p>
        </div>
        <Link to="/enterprise-2/research" className="e2-btn e2-btn-outline" data-testid="e2-thinking-all">
          See all research
          <Arrow />
        </Link>
      </div>

      <div className="e2-thinking-grid">
        {NOTES.map((n) => (
          <Link key={n.testid} to={n.to} className="e2-thinking-card" data-testid={n.testid}>
            <div className={`e2-thinking-cover ${n.tone}`}>
              <span className="e2-thinking-cover-glow" aria-hidden />
              <span className="e2-thinking-cover-text">{n.cover}</span>
            </div>
            <div className="e2-thinking-body">
              <div className="e2-thinking-meta">
                <span className="e2-thinking-tag">{n.tag}</span>
                <span>{n.date}</span>
                <span className="e2-thinking-dot" aria-hidden />
                <span>{n.read}</span>
              </div>
              <p className="e2-thinking-title">{n.title}</p>
              <span className="e2-thinking-read">Read the note <Arrow /></span>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
